import cmsService from "src/services/cmsService";

export const GET_PAGE_CMS_REQUEST = "@cms/get-page-cms-request";
export const GET_PAGE_CMS_SUCCESS = "@cms/get-page-cms-success";
export const GET_PAGE_CMS_FAILURE = "@cms/get-page-cms-failure";

export const GET_PAGE_CMS_CONTENT_REQUEST = "@cms/get-page-cms-content-request";
export const GET_PAGE_CMS_CONTENT_SUCCESS = "@cms/get-page-cms-content-success";
export const GET_PAGE_CMS_CONTENT_FAILURE = "@cms/get-page-cms-content-failure";

export const CREATE_PAGE_CMS_REQUEST = "@cms/create-page-cms-request";
export const CREATE_PAGE_CMS_SUCCESS = "@cms/create-page-cms-success";
export const CREATE_PAGE_CMS_FAILURE = "@cms/create-page-cms-failure";

export const CREATE_CONTENT_OF_PAGE_CMS_REQUEST =
  "@cms/create-content-of-page-cms-request";
export const CREATE_CONTENT_OF_PAGE_CMS_SUCCESS =
  "@cms/create-content-of-page-cms-success";
export const CREATE_CONTENT_OF_PAGE_CMS_FAILURE =
  "@cms/create-content-of-page-cms-failure";

export const UPDATE_CONTENT_OF_PAGE_CMS_REQUEST =
  "@cms/update-content-of-page-cms-request";
export const UPDATE_CONTENT_OF_PAGE_CMS_SUCCESS =
  "@cms/update-content-of-page-cms-success";
export const UPDATE_CONTENT_OF_PAGE_CMS_FAILURE =
  "@cms/update-content-of-page-cms-failure";

export const DELETE_PAGE_CMS_REQUEST = "@cms/delete-page-cms-request";
export const DELETE_PAGE_CMS_SUCCESS = "@cms/delete-page-cms-success";
export const DELETE_PAGE_CMS_FAILURE = "@cms/delete-page-cms-failure";

export const DELETE_CONTENT_OF_PAGE_CMS_REQUEST =
  "@cms/delete-content-of-page-cms-request";
export const DELETE_CONTENT_OF_PAGE_CMS_SUCCESS =
  "@cms/delete-content-of-page-cms-success";
export const DELETE_CONTENT_OF_PAGE_CMS_FAILURE =
  "@cms/delete-content-of-page-cms-failure";

export function getPageCms() {
  return async (dispatch) => {
    try {
      dispatch({type: GET_PAGE_CMS_REQUEST});
      const response = await cmsService.getPageCms();
      dispatch({
        type: GET_PAGE_CMS_SUCCESS,
        payload: {response: response || []}
      });
    } catch (error) {
      dispatch({type: GET_PAGE_CMS_FAILURE});
      throw error;
    }
  };
}

export function getContentPage(query) {
  return async (dispatch) => {
    try {
      dispatch({type: GET_PAGE_CMS_CONTENT_REQUEST});
      const response = await cmsService.getContentPage(query);
      dispatch({
        type: GET_PAGE_CMS_CONTENT_SUCCESS,
        payload: {response: response || []}
      });
    } catch (error) {
      dispatch({type: GET_PAGE_CMS_CONTENT_FAILURE});
      throw error;
    }
  };
}

export function createPageCms(newPage) {
  return async (dispatch) => {
    try {
      dispatch({type: CREATE_PAGE_CMS_REQUEST});
      const response = await cmsService.createNewPage(newPage);
      dispatch({
        type: CREATE_PAGE_CMS_SUCCESS,
        payload: {response: response.data || []}
      });
    } catch (error) {
      dispatch({type: CREATE_PAGE_CMS_FAILURE});
      throw error;
    }
  };
}

export function createContentOfPageCms(newPage) {
  return async (dispatch) => {
    try {
      dispatch({type: CREATE_CONTENT_OF_PAGE_CMS_REQUEST});
      const response = await cmsService.createNewPage(newPage);
      dispatch({
        type: CREATE_CONTENT_OF_PAGE_CMS_SUCCESS,
        payload: {response: response || []}
      });
    } catch (error) {
      dispatch({type: CREATE_CONTENT_OF_PAGE_CMS_FAILURE});
      throw error;
    }
  };
}

export function updateContentOfPage(data) {
  return async (dispatch) => {
    try {
      dispatch({type: UPDATE_CONTENT_OF_PAGE_CMS_REQUEST});
      const response = await cmsService.updateContentOfPage(data);
      dispatch({
        type: UPDATE_CONTENT_OF_PAGE_CMS_SUCCESS,
        payload: {response: response.data || []}
      });
    } catch (error) {
      dispatch({type: UPDATE_CONTENT_OF_PAGE_CMS_FAILURE});
      throw error;
    }
  };
}

export function removeContentOfPage(id) {
  return async (dispatch) => {
    try {
      dispatch({type: DELETE_CONTENT_OF_PAGE_CMS_REQUEST});
      const response = await cmsService.removeContentOfPage(id);
      dispatch({
        type: DELETE_CONTENT_OF_PAGE_CMS_SUCCESS,
        payload: {response: response || {}}
      });
    } catch (error) {
      dispatch({type: DELETE_CONTENT_OF_PAGE_CMS_FAILURE});
      throw error;
    }
  };
}
